import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../../actions'
import axios from 'axios'
import { Container, Button, TableRow, TableHeaderCell, TableHeader, TableCell, TableBody, Table, Grid, GridColumn, Input, Confirm, Icon } from 'semantic-ui-react'

const ConsumersTable = () => {
    const [isSearching, setIsSearching] = useState(false)
    const [searchString, setSearchString] = useState('')
    const [showDeleteConfirmationPopup, setShowDeleteConfirmationPopup] = useState(false)
    const [idToDelete, setIdToDelete] = useState(null)
    const [deleteConfirmContentString, setDeleteConfirmContentString] = useState('')

    const admins = useSelector(state => state.admins)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(actions.fetchAdmins())
    }, [dispatch])

    const renderTableRows = () => {
        const data = isSearching ? admins.filter(user =>
                  (user.name?.toLowerCase()?.includes(searchString.toLowerCase()) ||
                   user.email?.toLowerCase()?.includes(searchString.toLowerCase()) ||
                   user.role?.toLowerCase()?.includes(searchString.toLowerCase()))
              ) : admins
        const rows = []
        for (const [i, user] of data.entries()) {
            let rank = user.rank || ''
            rows.push(
                <TableRow key={i} style={{ cursor: 'pointer' }} onClick={() => handleEditClicked(user)}>
                    <TableCell style={{ color: 'white' }}>
                        {!user.name ? user.givenName + ' ' + user.familyName : user.name}
                    </TableCell>
                    <TableCell style={{ color: 'white' }}>{user.email}</TableCell>
                    <TableCell style={{ color: 'white' }}>{rank}</TableCell>
                    <TableCell collapsing>
                        <Button inverted circular basic icon onClick={e => handleDeleteClicked(e, user)}><Icon inverted name="trash alternate" /></Button>
                    </TableCell>
                </TableRow>
            )
        }
        return rows
    }

    const renderTable = () => {
        if (!admins) return null
        return (
            <Table size={window.innerWidth < 768 ? 'small' : null} celled striped unstackable inverted style={window.innerWidth < 768 ? { overflowX: 'auto', display: 'block', whiteSpace: 'nowrap', marginTop: 20 } : { marginTop: 20 }}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Name</TableHeaderCell>
                        <TableHeaderCell width="5">Email</TableHeaderCell>
                        <TableHeaderCell width="4">Role</TableHeaderCell>
                        <TableHeaderCell></TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>{renderTableRows()}</TableBody>
            </Table>
        )
    }

    const handleChangeSearchField = e => {
        const { value } = e.target
        if (value === '') {
            setIsSearching(false)
        } else {
            setIsSearching(true)
            setSearchString(value)
        }
    }

    const handleEditClicked = user => {

    }

    const handleDeleteClicked = (e, user) => {
        e.stopPropagation()
        if (showDeleteConfirmationPopup) return
        const contentString = "Delete user '" + user.name + "'?"
        setIdToDelete(user._id)
        setDeleteConfirmContentString(contentString)
        setShowDeleteConfirmationPopup(true)
    }

    const handleDeleteCancel = () => {
        setShowDeleteConfirmationPopup(false)
    }

    const handleDeleteConfirm = async () => {
        await axios.delete('/api/user/' + idToDelete)
            .then(() => {
                setShowDeleteConfirmationPopup(false)
                dispatch(actions.fetchAdmins())
            })
            .catch(err => {
                console.log(`delete user failed with error: ${err}`)
                alert(`Failure deleting user, please try again. Error: ${err}`)
            })
    }

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            <Grid style={{ marginTop: 10, marginBottom: 15 }}>
                <GridColumn floated="left" width={5}>
                    <h1 style={{ color: 'white' }}>Consumers</h1>
                </GridColumn>
                <GridColumn width={6}>
                    <Input inverted fluid action={{ icon: 'search', color: 'teal', inverted: true }} placeholder="Search consumer..." onChange={handleChangeSearchField} style={{ border: '1px #333 solid' }} input={<input style={{ backgroundColor: '#1b1c1d', color: 'white' }} />}/>
                </GridColumn>
                <GridColumn floated="right" width={5}></GridColumn>
            </Grid>
            {renderTable()}
            <Confirm inverted open={showDeleteConfirmationPopup} onCancel={handleDeleteCancel} onConfirm={handleDeleteConfirm} header="Confirmation" content={deleteConfirmContentString} cancelButton="Cancel" confirmButton="Delete"/>
        </Container>
    )
}

export default ConsumersTable